import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-h-payment-details"
}
const _hoisted_2 = { class: "p-h-payment-details__body" }
const _hoisted_3 = { class: "p-h-payment-details__price" }
const _hoisted_4 = { class: "p-h-payment-details__price__text" }
const _hoisted_5 = { class: "p-h-payment-details__body" }
const _hoisted_6 = { class: "p-h-payment-details__price" }
const _hoisted_7 = { class: "p-h-payment-details__price__text" }
const _hoisted_8 = { class: "p-h-payment-details__note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_HContainer = _resolveComponent("HContainer")!
  const _component_HBorderPanel = _resolveComponent("HBorderPanel")!

  return (_ctx.paymentDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_HBorderPanel, { "body-margin": "s" }, {
          heading: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("お支払い内容", -1)
          ])),
          footer: _withCtx(() => [
            _createVNode(_component_SmallText, {
              size: 14,
              weight: "bold"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("ご利用ポイント合計", -1)
              ])),
              _: 1,
              __: [1]
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.addComma(_ctx.paymentDetails.usage_point)), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "p-h-payment-details__price__unit" }, "ポイント", -1))
              ])
            ]),
            _createVNode(_component_HContainer, { "margin-size": "s" }, {
              content: _withCtx(() => [
                _createVNode(_component_SmallText, {
                  size: 14,
                  weight: "bold"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("クレジット決済金額", -1)
                  ])),
                  _: 1,
                  __: [3]
                }),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.addComma(_ctx.paymentDetails.credit_card.amount)), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "p-h-payment-details__price__unit" }, "円", -1))
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" （価格：" + _toDisplayString(_ctx.paymentDetails.credit_card.price) + "円／ 消費税" + _toDisplayString(_ctx.paymentDetails.credit_card.tax) + "円） ", 1),
                      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" 消費税率：" + _toDisplayString(_ctx.paymentDetails.tax_rate) + "％ ", 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}